import script from "./ProductGuide.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductGuide.vue?vue&type=script&setup=true&lang=js"

import "./ProductGuide.vue?vue&type=style&index=0&id=0fd0a438&scoped=true&lang=css"
import "./ProductGuide.vue?vue&type=style&index=1&id=0fd0a438&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0fd0a438"]])

export default __exports__